import React from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import { ChipItem } from '../types'
import { SX } from '../constants'

type Props = {
  visibleChips: ChipItem[]
  extraCount: number
  onChipDelete: (chip: ChipItem) => void
  onOverflowClick: () => void
}

export const ChipsSection = ({
  visibleChips,
  extraCount,
  onChipDelete,
  onOverflowClick,
}: Props) => (
  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
    {visibleChips.map((chip) => (
      <Chip
        key={chip.key}
        label={chip.label}
        onDelete={() => onChipDelete(chip)}
        color="primary"
        variant="outlined"
        sx={SX.chip}
      />
    ))}
    {extraCount > 0 && (
      <Chip
        key="overflow-chip"
        label={`+${extraCount}`}
        onClick={onOverflowClick}
        color="primary"
        variant="outlined"
        sx={{ ...SX.chip, cursor: 'pointer' }}
      />
    )}
  </Box>
)
